import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateApiService extends ApiService<any> {
  static readonly TEMPLATE_SEARCH_FIELDS = ['name', 'id'];

  private readonly presentationsTemplatesUrl =
    environment.SPRING_ENDPOINT_URL + '/v2/presentations/list-templates';

  constructor(
    private companyStateService: CompanyStateService,
    protected httpClient: HttpClient,
  ) {
    super(httpClient);
  }

  override getResourceUrl(): string {
    return '/v2/templates';
  }

  private _createSearchQuery(fields, search) {
    var query = '';
    for (var i in fields) {
      query += 'OR ' + fields[i] + ':~\"' + search + '\" ';
    }
    query = query.substring(3);
    return query.trim();
  }

  listPresentationTemplates(search, cursor?: string) {
    var query = search.query
      ? this._createSearchQuery(
          TemplateApiService.TEMPLATE_SEARCH_FIELDS,
          search.query,
        )
      : '';

    const params = new HttpParams()
      .set('companyId', this.companyStateService.getSelectedCompanyId())
      .set('search', query)
      .set('cursor', cursor)
      .set('count', search.count)
      .set('sort', search.sortBy + (search.reverse ? ' desc' : ' asc'));

    return firstValueFrom(
      this.httpClient.get<any>(this.presentationsTemplatesUrl, {
        params,
      }),
    );
  }

  listTemplates(search, cursor?: string) {
    const params = new HttpParams()
      .set('companyId', this.companyStateService.getSelectedCompanyId())
      .set('search', search.query || '*')
      .set('filter', search.filter || '')
      .set('cursor', cursor)
      .set('count', search.count)
      .set('sort', search.sort || 'defaultOrderWeight ASC');

    return firstValueFrom(super.listAsObservable(params));
  }

  getTemplate(productId): any {
    return firstValueFrom(
      super.requestAsObservable('', 'GET', `by-product/${productId}`),
    );
  }
}
